import React, { useState, useEffect } from "react";
import { getJobIcon } from "../../../utils/getJobIcon";
import MaterialIcon from "../MaterialIcon";

const JobConfigrationCopy = ({ editJob, allJobs = [] }) => {
  const [selectedJob, setSelectedJob] = useState("");
  const [jobDescription] = useState(editJob?.description || "");

  useEffect(() => {
    setSelectedJob(editJob?.job_id || "");
  }, [editJob]);

  const currentJob = allJobs.find((job) => job.id === selectedJob);

  const jobName = editJob?.params?.job_name || currentJob?.name || "";

  return (
    <div className="builder_form">
      <div className="flex_column gap_2">
        {currentJob && (
          <div className="post_activity_value d_flex" style={{ alignItems: "center" }}>
            <div>
              {getJobIcon(currentJob.job_template) ? (
                <img
                  src={getJobIcon(currentJob.job_template)}
                  alt={`${currentJob.name} Icon`}
                  style={{
                    width: "50px",
                    height: "50px",
                    marginRight: "5px",
                    verticalAlign: "middle"
                  }}
                />
              ) : (
                <MaterialIcon
                  name="text_fields"
                  style={{
                    marginRight: "8px",
                    width: "30px",
                    height: "30px",
                    verticalAlign: "middle"
                  }}
                />
              )}
            </div>
            {jobName}
          </div>
        )}
        <div>{jobDescription}</div>
      </div>
    </div>
  );
};

export default JobConfigrationCopy;
